<template>
  <v-navigation-drawer persistent :value="open" @input="value => updateMenu({ open: value })" light enable-resize-watcher>
    <v-list class="pa-0">
      <v-list-item>
        <v-list-tile avatar tag="div">
          <v-list-tile-avatar>
            <img :src="currentUser.picture.thumb">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ currentUser.nickname }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon router :href="{ name: 'Account', params: { tab: 'profile' } }">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list-item>
    </v-list>
    <v-list class="pt-0" dense>
      <v-divider></v-divider>
      <template v-for="(menu, i) in menuList">

        <v-list-group :key="i" v-if="menu.children && valid(menu)" :value="menu.active">
          <v-list-tile slot="item">
            <v-list-tile-action>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>keyboard_arrow_down</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <application-menu-item
            v-for="(subMenu, j) in menu.children" :key="j"
            v-if="valid(subMenu)"
            :route="subMenu.route"
            :title="subMenu.title"
            :icon="subMenu.icon">
          </application-menu-item>
        </v-list-group>

        <application-menu-item :key="i" v-else-if="valid(menu)"
          :route="menu.route"
          :title="menu.title"
          :icon="menu.icon">
        </application-menu-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import Utils from '@/utils/default'
  import ApplicationMenuItem from '@/components/ApplicationMenuItem'
  export default {
    components: {
      ApplicationMenuItem
    },
    computed: {
      ...mapGetters({
        open: 'application/menuOpen',
        servicesScopes: 'skiliko/services/offers',
        categories: 'skiliko/services/categories',
        currentUser: 'skiliko/session/currentUser'
      }),
      scopesMetas () {
        return {
          public: { icon: 'public', title: this.$t('applicationmenu.menu.services.public') },
          promotion: { icon: 'local_activity', title: this.$t('applicationmenu.menu.services.promotions') },
          private: { icon: 'vpn_lock', title: this.$t('applicationmenu.menu.services.private') }
        }
      },
      menuList () {
        return [
          {
            title: this.$t('applicationmenu.menu.dashboard.default'),
            icon: 'dashboard',
            children: [
              { title: this.$t('applicationmenu.menu.dashboard.todo'), route: { name: 'Dashboard' }, icon: 'list' },
              { title: this.$t('applicationmenu.menu.dashboard.revenues'), route: { name: 'PlatformRevenues' }, icon: 'equalizer', if: () => this.$can('view', 'platformIncomes') },
              { title: this.$t('applicationmenu.menu.dashboard.gains'), route: { name: 'Gains' }, icon: 'attach_money' },
              { title: this.$t('applicationmenu.menu.dashboard.availabilities'), route: { name: 'Availabilities' }, icon: 'event_available', if: () => this.$can('view', 'platformAvailabilities') },
              { title: this.$t('applicationmenu.menu.dashboard.statistics'), route: { name: 'Statistics' }, icon: 'insert_chart' },
              { title: this.$t('applicationmenu.menu.dashboard.accounts'), route: { name: 'Accounts' }, icon: 'calculate', if: () => this.$can('view', 'platformDistribution') }
            ]
          },
          { title: this.$t('applicationmenu.menu.customers'), route: { name: 'Users' }, icon: 'people', if: () => this.$can('view', 'customers') },
          { title: this.$t('applicationmenu.menu.messenger'), route: { name: 'Messenger' }, icon: 'chat', if: () => this.$can('use', 'messenger') },
          { title: this.$t('applicationmenu.menu.purchases'), route: { name: 'Purchases' }, icon: 'local_atm' },
          {
            title: this.$t('applicationmenu.menu.feedbacks.default'),
            icon: 'rate_review',
            children: [
              { title: this.$t('applicationmenu.menu.feedbacks.pending'), route: { name: 'FeedbacksPending' }, icon: 'sms' },
              { title: this.$t('applicationmenu.menu.feedbacks.accepted'), route: { name: 'FeedbacksAccepted' }, icon: 'done' },
              { title: this.$t('applicationmenu.menu.feedbacks.rejected'), route: { name: 'FeedbacksRejected' }, icon: 'block', if: () => this.$can('viewBlocked', 'feedbacks') }
            ]
          },
          {
            title: this.$t('applicationmenu.menu.services.default'),
            icon: 'perm_phone_msg',
            children: [
              { title: this.$t('applicationmenu.menu.services.create'), route: { name: 'ServiceCreation' }, icon: 'add', if: () => this.$can('update', 'services') },
              ...this.servicesScopes.map(scope => ({
                title: this.scopesMetas[scope].title,
                route: { name: 'Services', query: { scope } },
                icon: this.scopesMetas[scope].icon,
                if: () => this.scopesMetas[scope] || this.$can('update', 'services')
              }))
            ]
          },
          {
            title: this.$t('applicationmenu.menu.pages.default'),
            icon: 'library_books',
            if: () => this.categories.length > 0,
            children: this.categories.map(scope => ({
              title: Utils.toHumanize(scope),
              route: { name: 'Services', query: { scope } },
              icon: 'description',
              if: () => this.$can('update', 'services')
            }))
          },
          { title: this.$t('applicationmenu.menu.settings.team'), route: { name: 'Team' }, icon: 'group_add', if: () => this.$can('manage', 'team') },
          { title: this.$t('applicationmenu.menu.settings.transfers'), route: { name: 'Transfers' }, icon: 'account_balance_wallet', if: () => this.$can('manage', 'transfers') },
          { title: this.$t('applicationmenu.menu.settings.customization'), route: { name: 'Customization' }, icon: 'tune', if: () => this.$can('customize', 'platform') },
          { title: this.$t('applicationmenu.menu.settings.links'), route: { name: 'Links' }, icon: 'link', if: () => this.$can('customize', 'links') }
        ]
      }
    },
    methods: {
      ...mapMutations({
        updateMenu: 'application/UPDATE_MENU'
      }),
      valid (menu) {
        return !menu.if || (menu.if && menu.if())
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ApplicationMenu.vue